// extracted by mini-css-extract-plugin
export default {"headerBar":"Dashboard_headerBar__TCZdV","rounds":"Dashboard_rounds__tgsp4","ant-card":"Dashboard_ant-card__YRw8S"};